// cSpell:ignore redirector REDIRECTOR
import { getPortalRuntimeConfig } from '../../services/runtimeConfig';

export const getRedirectUriDetails = ({
  redirectUri,
  state,
}: {
  redirectUri: string;
  state?: string;
}) => {
  const { loginRedirectorUrl: redirectorUrl } = getPortalRuntimeConfig();
  if (!redirectorUrl) {
    return { redirectUri, state: state ?? '' };
  }

  return {
    redirectUri: redirectorUrl,
    state: JSON.stringify({ _redirect: redirectUri, _str: state }),
  };
};
